export default {
      id: "skipPrevious-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#skipPrevious-usage",
      toString: function () {
        return this.url;
      }
    }